import { Outlet, useLocation } from 'react-router-dom'
import ToolBarRightContainer from 'components/toolbar/ToolBarRightContainer';
import ToolBarLeftContainer from 'components/toolbar/ToolBarLeftContainer';
import SideBarNav from 'components/sidebar/SideBarNav';
import { useState } from 'react';
import Paginator from 'components/others/Paginator';
import { useGlobal } from 'context/GlobalContext';
import LocaleFilter from 'components/footer/LocaleFilter';
import { LeadSelected } from 'modules/lead';
import { ObjectSelected } from 'modules/objects';
import { ProductsSelect } from 'modules/product';
import { ProductSetsSelect } from 'modules/product';
import { ServicesSelect } from 'modules/product';
import { UserSelected, UserNameItem } from 'modules/user';
import { ClientSelected } from 'modules/client';
import { SideBarTariff } from 'modules/admin';
import { WarehouseNameOffcanvas } from 'modules/warehouse';


const MainLayout = () => {
 
    const [ pcSideBarShow, setPcSideBarShow ] = useState(true);
    const [ mobSideBarShow, setMobSideBarShow ] = useState(false);
    const { g } = useGlobal();
    const location = useLocation();

  
    return ( 
    <div> 
        <SideBarNav   
            pcSideBarShow={pcSideBarShow}
            setPcSideBarShow={setPcSideBarShow}
            mobSideBarShow={mobSideBarShow}
            setMobSideBarShow={setMobSideBarShow}
            tariffSlot={<SideBarTariff />}
            WarehouseNameOffcanvas={WarehouseNameOffcanvas}
        />
        <div className="pc-header">
            <div className="header-wrapper ps-1">
                <div className="me-auto pc-mob-drp">
                    <ToolBarLeftContainer 
                        pcSideBarShow={pcSideBarShow}
                        setPcSideBarShow={setPcSideBarShow}
                        mobSideBarShow={mobSideBarShow}
                        setMobSideBarShow={setMobSideBarShow}/>
                </div>
                <div className="ms-auto">
                    <ToolBarRightContainer UserNameItem={UserNameItem} />
                </div>
            </div>
        </div>   
        <div className="pc-container"
            style={{marginBottom:'130px'}}>
            <div className='pc-content pt-0'>
                <Outlet />      
            </div>
        </div>
  
        <footer className="pc-footer d-flex">
            {(g.localeFilterActive) && (
                <div>
                <LocaleFilter/>
                </div>
                )}
             
            <div className="footer-wrapper container-fluid">
                
                {
                    // Пагінатор
                    ((g.paginator?.[location.pathname]) && (!g.footerComponent)) && (
                        <Paginator paginator={g.paginator?.[location.pathname]}/>) 
                }

                {
                    // Компонент футера
                    (g.footerComponent && (g.footerComponent))
                }
 
            </div>
        </footer>

        <LeadSelected preload />
        <ObjectSelected preload />
        <ProductsSelect preload />
        <ProductSetsSelect preload />
        <ServicesSelect preload />
        <UserSelected preload />
        <ClientSelected preload />
    </div>
    )
}

export default MainLayout;
